import React from 'react'
import { ArrowLeftOutlined, ArrowRightOutlined, ReloadOutlined } from '@ant-design/icons'

export default function BrowserBorder(props) {
  const hasPadding = props.hasPadding ?? true
  const getUrl = () => {
    const sanity_name = (name) => {
      if (!name) return ''
      return name.replaceAll(' ', '_').replaceAll('__', '_')
    }
    const paths = props.location.pathname.split('/')
    let suffix = paths[paths.length - 2]
    if (suffix === 'home') suffix = ''
    try {
      if (paths[paths.length - 3] === 'art') {
        suffix = 'art/' + suffix
      }
    } catch (e) {}
    return 'https://revart.co/showcase/' + props.artistId + '_' + sanity_name(props.artistName) + '/' + suffix
  }
  return (
    <div
      style={{
        borderBottom: '1px solid rgba(0,0,0,0.15)',
        borderLeft: '1px solid rgba(0,0,0,0.15)',
        borderRight: '1px solid rgba(0,0,0,0.15)',
        borderRadius: 12,
        backgroundColor: 'rgb(57,94,106)'
      }}
    >
      <div style={{ width: '100%', height: 36, display: 'flex', alignItems: 'center', gap: 6 }}>
        <div
          style={{
            width: 12,
            height: 12,
            backgroundColor: 'rgb(195,48,50)',
            borderRadius: 50,
            marginLeft: 16
          }}
        />
        <div style={{ width: 12, height: 12, backgroundColor: 'rgb(241,234,26)', borderRadius: 50 }} />
        <div style={{ width: 12, height: 12, backgroundColor: '#64af29', borderRadius: 50 }} />
      </div>
      <div
        style={{
          width: '100%',
          backgroundColor: 'white',
          height: 36,
          gap: 4,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          borderBottom: '1px solid rgba(0,0,0,0.3)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 10, marginLeft: 12 }}>
          <ArrowLeftOutlined style={{ fontSize: 12 }} />
          <ReloadOutlined style={{ fontSize: 12 }} />
          <ArrowRightOutlined style={{ fontSize: 12 }} />
        </div>
        <div
          style={{
            width: '70%',
            backgroundColor: 'gainsboro',
            height: 28,
            borderRadius: 50,
            display: 'flex',
            alignItems: 'center',
            marginLeft: 12
          }}
        >
          <a target={'_blank'} href={getUrl()} style={{ color: 'black' }}>
            <span
              style={{
                fontSize: 12,
                padding: 4,
                paddingLeft: 12
              }}
            >
              {getUrl()}
            </span>
          </a>
        </div>
      </div>
      {hasPadding && <div style={{ width: '100%', height: 24, backgroundColor: 'white' }} />}
      <div style={{ backgroundColor: 'white', height: '100%', width: '100%' }}>{props.children}</div>
    </div>
  )
}
